import React from "react";
 
const Footer = () => (
	<footer className="main-footer">
		<div className="main-footer__copyright">Datassential {new Date().getFullYear()} – All Rights Reserved</div>
	</footer>
)
 
export default Footer;